<template>
<div id="contents">

  <div id="works" class="page_contents">

    <div id="works_contents">
      <div id="works_program_show" v-if="program">

        <div id="works_program_show_main" class="page_main_contents">
          <p id="works_program_show_main_img"><img :src="program.kv_image" alt="番組ロゴ" /></p>
          <p class="page_close hover"><router-link v-bind:to="{name: 'program_index'}"><img src="../assets/img/common/page/close_icon.png" width="55" alt="閉じるボタン" ></router-link></p>
        </div><!-- #works_program_show_main -->

        <div id="works_program_show_body" class="page_main_contents">
          <div id="works_program_show_program_name">
            <p class="program_label">{{ program.category }}</p>
            <h1 v-html="program.title"></h1>

            <p v-if="program.createtv === 'asahi'" class="program_type"><img src="../assets/img/works/program/tv-asahi.jpg" width="93" alt="テレビ朝日" /></p>
            <p v-else-if="program.createtv === 'bs'" class="program_type"><img src="../assets/img/works/program/img_abs.gif" width="93" alt="BS朝日" /></p>
            <p v-else class="program_type">{{ program.createtv }}</p>

          </div><!-- #works_program_show_program_name -->

          <div id="works_program_show_program_info">
            <p id="works_program_show_program_info_time">{{ program.day_off_week }}<br /><span v-html="program.date"></span></p>
            <div class="read" v-html="program.content"></div>
          </div><!-- #works_program_show_program_info -->
        </div><!-- #works_program_show_body -->

      </div><!-- #works_program_show -->
    </div><!-- #works_contents -->

    <ul id="page_nav" v-if="program">

      <p v-if="program.next_post_id" class="hover"><router-link v-bind:to="{name: 'works_program_show', params: {id: program.next_post_id}}"><img src="../assets/img/common/page/arrow.png" width="20" alt="右矢印" ></router-link></p>
      <p v-else></p>

      <p v-if="program.prev_post_id" class="hover"><router-link v-bind:to="{name: 'works_program_show', params: {id: program.prev_post_id}}"><img src="../assets/img/common/page/arrow.png" width="20" alt="左矢印" ></router-link></p>
      <p v-else></p>

    </ul><!-- #page_nav -->

  </div><!-- #works -->



</div><!-- #contents -->
</template>

<script>
export default {
  name: 'program_show',
  data() {
    return {
      api_url: this.$parent.api_base_url+'/api/program/show.php',
      loading: false,
      program: null,
      error: null
    }
  },
  methods: {
    fetch_program(){
      this.$axios
        .get(this.api_url ,{
          params: {
            id: this.$route.params.id
          }
        })
        .then(response => {
          this.program = response.data.item[0]
        })
        .catch(error => {
          console.log(error)
          this.error = true
        })
        .finally()
    }
  },
  watch: {
    '$route' (to, from) {
      this.fetch_program()
    }
  },
  mounted () {
    this.fetch_program()
  },
  updated (){
    var queue = new createjs.LoadQueue(true);
    const ts = this;
    queue.loadManifest([this.program.kv_image],true);
    queue.addEventListener("complete",function(){
      ts.$emit('page_fade')
    });
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/program_show.vue